import React from 'react'
import { Sidebar, Segment, Menu, Icon } from 'semantic-ui-react'
import { BrowserRouter , Switch, Route } from 'react-router-dom'
import ContactsListContainer from 'components/contacts/ContactsListContainer';
import ContactsMenuContainer from 'components/contacts/ContactsMenuContainer';
import Contact from 'components/contacts/Contact';

export default class Contacts extends React.Component {
  render () {
    return (
      <div>
        <Switch>
          <Route path={Routes.contact_path({ id: ":id", _options: true})} render={ props => (
            <Sidebar.Pushable as={Segment} className= "min-height-90">
              <ContactsMenuContainer/>
              <Sidebar.Pusher className="left-sidebar-margin">
                <Contact contactId={props.match.params.id}/>
              </Sidebar.Pusher>
            </Sidebar.Pushable>
           )} />

          <Route path={Routes.contacts_path()} component={ContactsListContainer}/>
        </Switch>
      </div>
    )
  }
}

